// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-bulk-case-upload-FileUpload-module__root--yTVt8","buttonText":"src-components-page-bulk-case-upload-FileUpload-module__buttonText--36d_1"};